import request from './request'

export function listTechnology(data) {
  return request.post('/mes/technologies/list', data)
}
export function selectTechnologyByProduct(productId) {
  return request.get('/mes/technologies/select-by-product/' + productId)
}
export function getTechnology(id) {
  return request.get('/mes/technologies/' + id)
}
export function saveTechnology(data) {
  return request.post('/mes/technologies', data)
}
export function updateTechnology(data) {
  return request.post('/mes/technologies/update', data)
}
export function deleteTechnology(ids) {
  return request.post('/mes/technologies/delete', ids)
}
export function acceptTechnology(technologyId) {
  return request.post('/mes/technologies/accept', { technologyId })
}
export function rejectTechnology(technologyId) {
  return request.post('/mes/technologies/reject', { technologyId })
}
export function unacceptTechnology(technologyId) {
  return request.post('/mes/technologies/unaccept', { technologyId })
}
export function copyTechnology(technologyId) {
  return request.post('/mes/technologies/copy', { technologyId })
}
export function setMasterTechnology(technologyId) {
  return request.post('/mes/technologies/set-master', { technologyId })
}
